import React, { useState } from 'react'

function ReportsList({donor_title, beneficiary_title, donationFlag}) {
  const [openForDonor, setOpenForDonor] = useState(false)
  const [openForBeneficiary, setOpenForBeneficiary] = useState(false)


  return (
    <div>
      <div class="mt-5"></div>
      <div class="row">
      <div class="col-sm-6 col-md-4">
          <a href="/reports/donor_export?initialize=true">
          <div class="card card-stats card-round">
              <div class="card-body">
              <div class="row">
                  <div class="col-5">
                  <div class="icon-big text-center">
                      <i class="fa fa-solid fa-file text-danger-icon"></i>
                  </div>
                  </div>
                  <div class="col-7 col-stats">
                  <div class="numbers">
                      <h4 class="card-title">
                      { donor_title } Report
                      </h4>
                      <p class="card-category">Export { donor_title } Data</p>
                  </div>
                  </div>
              </div>
              </div>
          </div>
          </a>
      </div>
      <div class="col-sm-6 col-md-4">
          <a href="/reports/beneficiary_export?initialize=true">
          <div class="card card-stats card-round">
              <div class="card-body">
              <div class="row">
                  <div class="col-5 col-sm-4 col-md-3">
                  <div class="icon-big text-center">
                      <i class="fa fa-solid fa-child text-danger-icon"></i>
                  </div>
                  </div>
                  <div class="col-7 col-sm-8 col-md-9 col-stats">
                  <div class="numbers">
                      <h4 class="card-title">
                      { beneficiary_title } Report
                      </h4>
                      <p class="card-category">Export { beneficiary_title } Data</p>
                  </div>
                  </div>
              </div>
              </div>
          </div>
          </a>
      </div>
      {donationFlag &&
          <div class="col-sm-6 col-md-4">
          <a href="/reports/donation_export?initialize=true">
              <div class="card card-stats card-round">
              <div class="card-body">
                  <div class="row">
                  <div class="col-5 col-sm-4 col-md-3">
                      <div class="icon-big text-center">
                      <i class="fa fa-solid fa-money-bill text-danger-icon"></i>
                      </div>
                  </div>
                  <div class="col-7 col-sm-8 col-md-9 col-stats">
                      <div class="numbers">
                      <h4 class="card-title">
                          Donations Report
                      </h4>
                      <p class="card-category">Export Donations Data</p>
                      </div>
                  </div>
                  </div>
              </div>
              </div>
          </a>
          </div>
      }
      </div>
  </div>
  )
}

export default ReportsList
